import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import './UserManage.scss';
import { getAllUsers, createNewUserService, deleteUserService, editUserService } from '../../../services/userService';
import ModalUser from './ModalUser';
import ModalEditUser from './ModalEditUser';
import { emitter } from '../../../utils/emitter' // ham tao su kien
class UserManage extends Component {

    constructor(props) { // Ham khoi tao
        super(props);
        this.state = {
            arrUsers: [],
            isOpenModal: false,
            isOpenModalEditUser: false,
            userEdit: [],
        }
    }

    async componentDidMount() {  // set bien, goi api
        await this.getAllUserFromReact()

    }
    getAllUserFromReact = async () => {
        let response = await getAllUsers("All");
        if (response && response.errCode == 0) {
            this.setState({
                arrUsers: response.users
            })
            console.log(this.state.arrUsers);
        }
    }
    createNewUser = async (data) => {

        try {
            let response = await createNewUserService(data);
            if (response && response.errCode !== 0) {
                await this.getAllUserFromReact()
                this.setState({
                    isOpenModal: false,
                })
                emitter.emit('EVENT_CLEAR_MODAL_DATA', { "id": "your id" });

            } else {
                console.log("user didn't create");
            }

        } catch (error) {

        }
    }
    editUser = async (data) => {
        try {
            let response = await editUserService(data);
            if (response && response.errCode !== 0) {
                await this.getAllUserFromReact()
                this.setState({
                    isOpenModalEditUser: false,
                })
                // emitter.emit('EVENT_CLEAR_MODAL_DATA', { "id": "your id" });
                console.log('trang thai tra ve ham edit: ', response)
            } else {
                console.log("user didn't create");
            }

        } catch (error) {

        }
    }
    handleAddNewUser = () => {
        this.setState({
            isOpenModal: true
        })
        // alert("from handleAddNewUser");
    }
    handleDeleteUser = async (data) => {

        let response = await deleteUserService(data);
        if (response && response.errCode !== 0) {
            await this.getAllUserFromReact()
            this.setState({
                isOpenModal: false,
            })

        } else {
            console.log("user didn't create");
        }

    }
    handleEditUser = async (data) => {

        this.setState({
            isOpenModalEditUser: true,
            userEdit: data
        })
    }
    toogleUserModal = () => {
        this.setState({
            isOpenModal: !this.state.isOpenModal
        })
    }
    toogleUserEditModal = () => {
        this.setState({
            isOpenModalEditUser: !this.state.isOpenModalEditUser
        })
    }
    render() {
        console.log('check render : ', this.state.isOpenModal);
        let arrUsers = this.state.arrUsers;
        // console.log('check render : ', arrUsers);
        // props - properties, nested, lay data tu Thang cha chuyen cho thang con, thang cha lay du lieu goc tu API
        return (
            <div className="users-container">
                <ModalUser
                    isOpen={this.state.isOpenModal}
                    tooglefromParent={this.toogleUserModal}
                    createNewUser={this.createNewUser}
                />
                {this.state.isOpenModalEditUser &&
                    <ModalEditUser
                        isOpen={this.state.isOpenModalEditUser}
                        tooglefromParent={this.toogleUserEditModal}
                        currentUser={this.state.userEdit}
                        editCurrentUser={this.editUser}
                    // createNewUser={this.createNewUser}
                    />
                }

                <div className='title text-center'> Manage User by Admin</div>
                <div className="mx-1">
                    <button class="btn btn-primary px-3"
                        onClick={() => this.handleAddNewUser()}
                    ><i class="fas fa-plus"></i>Add new staff</button>

                </div>
                <div className='user-table mt-3 mx-1'>
                    <table id="customers">
                        <tr>
                            <th>email</th>
                            <th>Name</th>
                            <th>Address</th>
                            <th>Actions</th>
                        </tr>

                        {/* su dung vong lap MAP function javascript */}
                        {arrUsers && arrUsers.map((item, index) => {
                            // console.log('check map', item, index);
                            return (
                                <tr>

                                    <td>{item.email}</td>
                                    <td>{item.fullname}</td>
                                    <td>{item.address}</td>
                                    <td>
                                        <button className='btn-edit'
                                            onClick={() => this.handleEditUser(item)}
                                        ><i class="fas fa-pencil-alt"></i></button>
                                        <button className='btn-delete'
                                            onClick={() => this.handleDeleteUser(item)}
                                        > <i className="fas fa-trash-alt"></i></button>

                                    </td>
                                </tr>

                            )
                        })
                        }



                    </table>
                </div>
            </div >
        );
    }

}

const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserManage);
